// extracted by mini-css-extract-plugin
export default {"container":"Statystyki_container__qEQpN"};